import { useContext, useMemo } from 'react';
import ParentModelContext from '~/context/new-cars/ParentModelContext';

export type SelectionItem = {
  name: string;
  priceAdd: number;
};

export default function useYourSelections(): SelectionItem[] {
  const {
    customizeOptions,
    selectedOptions,
    selectedTrim,
    selectedTruckBodyStyle
  } = useContext(ParentModelContext);
  const {
    driveTypes,
    engines,
    exteriorColors,
    interiorColors,
    packageOptions
  } = customizeOptions.data;

  const trimPriceAdd = selectedTrim?.priceAdd ?? 0;
  const truckBodyStylePriceAdd = selectedTruckBodyStyle?.priceAdd ?? 0;

  return useMemo(() => {
    const selections: SelectionItem[] = [];

    if (selectedTrim) {
      selections.push({ name: selectedTrim.title, priceAdd: trimPriceAdd });
    }

    if (selectedTruckBodyStyle) {
      selections.push({
        name: selectedTruckBodyStyle.title,
        priceAdd: truckBodyStylePriceAdd
      });
    }

    if (!selectedOptions) return selections;

    const exteriorColor = exteriorColors.find(
      ({ code }) => code === selectedOptions.exteriorColorCode
    );
    if (exteriorColor) {
      selections.push({
        name: `${exteriorColor.name} exterior`,
        priceAdd: exteriorColor.priceAdd
      });
    }

    const interiorColor = interiorColors.find(
      ({ code }) => code === selectedOptions.interiorColorCode
    );
    if (interiorColor) {
      selections.push({
        name: `${interiorColor.name} interior`,
        priceAdd: interiorColor.priceAdd
      });
    }

    const driveType = driveTypes.find(
      ({ name }) => name === selectedOptions.driveType
    );
    if (driveType) {
      selections.push({ name: driveType.name, priceAdd: driveType.priceAdd });
    }

    const engine = engines.find(
      ({ code }) => code === selectedOptions.engineCode
    );
    if (engine) {
      selections.push({ name: engine.name, priceAdd: engine.priceAdd });
    }

    packageOptions.forEach(({ code, name, priceAdd }) => {
      if (selectedOptions.packageOptionCodes?.includes(code)) {
        selections.push({ name, priceAdd });
      }
    });

    return selections.sort((a, b) => b.priceAdd - a.priceAdd);
  }, [
    driveTypes,
    engines,
    exteriorColors,
    interiorColors,
    packageOptions,
    selectedOptions,
    selectedTrim,
    selectedTruckBodyStyle,
    trimPriceAdd,
    truckBodyStylePriceAdd
  ]);
}
